'use strict';

import * as Cache from '../../../js/lib/cache';

module.exports = function(url , methode , data, p_processData, p_contentType){

    const $ = require('jquery');
    var showErrorBox = require('./showErrorBox.js') ;

    const processData =  ( p_processData == undefined ? true : p_processData );
    const contentType =  ( p_contentType == undefined ? 'application/x-www-form-urlencoded; charset=UTF-8' : p_contentType );

    return new Promise(function(resolve,reject){
        $.ajax({
            url : url,
            type: methode,
            processData: processData,
            contentType: contentType,
            data: Object.assign(data, window.oData),
            success: function(oResponse, status, xhr){

                resolve([oResponse, status, xhr]);
            },
            error: function (xhr, status, error) {

                reject(showErrorBox('Error', error));
            },
        }).always(() => {
          Cache.deleteByController();
        });
    });
};
